export default function HeroBlock({ data }) {
  const { image, overline, title, subtitle, cta_text, cta_link } = data || {};
  return (
    <section
      className="relative overflow-hidden"
      style={{ minHeight: image ? "60vh" : "auto" }}
    >
      {image && (
        <>
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `url(${image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.45) 0%, rgba(0,0,0,0.65) 100%)" }} />
        </>
      )}
      <div className={`relative max-w-5xl mx-auto px-6 md:px-8 lg:px-12 ${image ? "py-24 md:py-32" : "py-12 md:py-16"}`}>
        {overline && (
          <div className="overline mb-3" style={{ color: image ? "var(--wp-cream)" : "var(--wp-text-muted)", opacity: image ? 0.9 : 1 }}>
            {overline}
          </div>
        )}
        {title && (
          <h1
            className="font-display text-4xl sm:text-5xl lg:text-6xl leading-tight tracking-tight"
            style={{ color: image ? "var(--wp-cream)" : "var(--wp-text)" }}
          >
            {title}
          </h1>
        )}
        {subtitle && (
          <p
            className="mt-5 text-base md:text-lg leading-relaxed max-w-2xl"
            style={{ color: image ? "rgba(252,247,236,0.92)" : "var(--wp-text-muted)" }}
          >
            {subtitle}
          </p>
        )}
        {cta_text && cta_link && (
          <a href={cta_link} className="btn-primary inline-flex mt-7" data-testid="hero-block-cta">
            {cta_text}
            <i className="fa-solid fa-arrow-right text-xs" />
          </a>
        )}
      </div>
    </section>
  );
}
